import { apiGet, apiPost, apiPut } from "shared/services/apiRequest";

export const getZonesInfoForSystemIdentificationService = async (params) =>
    apiGet('/zones', { params });

export const createUOSZoneService = async (data) =>
    (await apiPost('/zones', data))?.data;

export const updateUOSZoneService = async (data) =>
    (await apiPut(`/zones/${data.zone_id}`, data))?.data;

export const getSSRsSwitchSizesService = async () =>
    (await apiGet('/ssrs/ssr-switch-sizes'))?.data;

export const addSSRsSwitchSizesService = async (value) =>
    (await apiPost('/ssrs/ssr-switch-sizes', { value }))?.data;

export const getSSRsRatingListService = async () =>
    (await apiGet('/ssrs/ssr-rating'))?.data;

export const addSSRsRatingService = async (value) =>
    (await apiPost('/ssrs/ssr-rating', { value }))?.data;
